import { render, staticRenderFns } from "./ManageVisitsEntitiesResultsNew.vue?vue&type=template&id=0110fa05&scoped=true&"
import script from "./ManageVisitsEntitiesResultsNew.vue?vue&type=script&lang=js&"
export * from "./ManageVisitsEntitiesResultsNew.vue?vue&type=script&lang=js&"
import style0 from "./ManageVisitsEntitiesResultsNew.vue?vue&type=style&index=0&id=0110fa05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0110fa05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0110fa05', component.options)
    } else {
      api.reload('0110fa05', component.options)
    }
    module.hot.accept("./ManageVisitsEntitiesResultsNew.vue?vue&type=template&id=0110fa05&scoped=true&", function () {
      api.rerender('0110fa05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/CommercialManagement/ManageVisitsEntitiesResultsNew.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/CommercialManagement/ManageVisitsEntitiesResultsNew.vue
// module id = Nega
// module chunks = 0